import React from 'react';
import { PlusCircle } from '@styled-icons/feather';
import classNames from 'classnames';
import { insertNodes } from '@udecode/plate-core';
import { DreamBlock } from '@typedream/core';
import styles from './NavbarToolbar.module.css';
import { useTPlateEditorRef } from '../../../../plate';
import { getDefaultNavbarValue } from '../../../../nodes/navbar/defaults';

function NavbarAddOption() {
  const editor = useTPlateEditorRef();
  const [isAddingNavbar, setIsAddingNavbar] = React.useState(false);
  const addNavbar = () => {
    insertNodes(editor, getDefaultNavbarValue() as unknown as DreamBlock, { at: [0, 0] });
    setIsAddingNavbar(true);
  };

  if (isAddingNavbar) return <></>;

  return (
    <div
      className={classNames(
        styles.navbarOptionsContainer,
        styles.navbarOptionsContainerStart,
      )}
      style={{ zIndex: 2 }}
    >
      <div
        className={styles.navbarOptions}
        onClick={addNavbar}
        role="none"
        data-testid="Button_AddNavbar"
      >
        <div
          className={classNames(
            styles.navbarOptionsTitle,
            styles.navbarOptionsTitleButton,
          )}
        >
          Add Navbar
          <PlusCircle size={15} style={{ marginLeft: 5 }} />
        </div>
      </div>
    </div>
  );
}

export default NavbarAddOption;
